import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { ServiceApiProvider } from '../../providers/service-api/service-api';
import { B08ReportManagementPage } from '../b08-report-management/b08-report-management';
import { ServiceGvariableProvider } from '../../providers/service-gvariable/service-gvariable';
/**
 * Generated class for the B08eInvoiceSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface branchInfo{
  BRANCH_ID: string;
  BRANCH_NAME: string;
  BRANCH_ACTIVE: string;  
}
interface userInfo{
  USER_ID: string;
  USER_NAME: string;

}
interface reportInfo{}
@IonicPage()
@Component({
  selector: 'page-b08g-shift-sales',
  templateUrl: 'b08g-shift-sales.html',
})
export class B08gShiftSalesPage {

  private todo : FormGroup;
  loading: any;
  Status: any;
  branchArr: branchInfo[] = [];
  branchItems: branchInfo[] = [];
  userArr: userInfo[] = [];
  userItems: userInfo[] = [];
  reportItems: reportInfo[] = [];
  public errorMessage: any = "";
  BRANCH_ID: any = 'All';
  USER_ID: any = 'All';
  invDateFrom: any;
  invDateTo: any;
  transDateFrom: any;
  transDateTo: any;
  plateNumber: any;
  filename:any;
  OVERALL:any;
  selectCORP_ID:any;
  report_request = {
    Report: "7",
    Param: "1",
    Data:{
      BRANCH_ID: "All",
      START: "",
      END: "",
      USER_ID: "All",
      SORT: "BRANCH_NAME",
      SORT_TYPE: "ASC"
    }
  }

  onSelectBranch(data)
  {
    this.userArr = [];
    this.userItems = [];
   if(data != "All")
   {
     
    let val = this.branchItems.find(c => c.BRANCH_ID === data);
    this.report_request.Data.BRANCH_ID = val["BRANCH_ID"];
    console.log(val["BRANCH_ID"]);
    let tbl = ["USER"];
    let column = ["BRANCH_ID"];
    let value = [val["BRANCH_ID"]];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
   

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
     
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.userArr = Records;
        this.userItems = this.userArr;
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
   }
   else
   {
    this.report_request.Data.BRANCH_ID ="All";
    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
   

    this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
     
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.userArr = Records;
        this.userItems = this.userArr;
      }
      else {
        //this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
   }
  }  
  onSelectUser(data)
  {
   if(data != "All")
   {
    let val = this.userItems.find(c => c.USER_ID === data);
    this.report_request.Data.USER_ID = val["USER_ID"];
   
   }
   else
   {
    this.report_request.Data.USER_ID ="All";
   }
  }  
  mybranchid:any;
  mybranchname:any;
  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi:ServiceApiProvider,
              public loadingCtrl: LoadingController, public global:ServiceGvariableProvider) {
    this.mybranchid = sessionStorage.getItem('userbranchid');

    //this.mybranchname = sessionStorage.getItem('userbranchname');
    if(this.mybranchid == 'null')
    {
      this.todo = this.formBuilder.group({
        branch: ['', Validators.required],
        user: ['', Validators.required],
        invDateFrom: [''],
        invDateTo: [''],
      });
    }
    else
    {
      this.todo = this.formBuilder.group({
        branch: [''],
        user: ['', Validators.required],
        invDateFrom: [''],
        invDateTo: [''],
      });
      this.report_request.Data.BRANCH_ID = this.mybranchid;
      let tbl = ["BRANCH"];
      let column = ["BRANCH_ID"];
      let value = [this.mybranchid];
      
      let tblkey = ["No"];
      let fktbl = ["No"];
      let fkkey = ["No"];

      let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

      let mydata = Object.assign(jsonitem);
      let json_data = this.serviceapi.json_readdata(mydata,"1");
      

      this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
        
        this.Status = result["Message"];
      
        if (this.Status == '1'){
          let Records = result["Records"];
          this.mybranchname = Records[0]["BRANCH_NAME"];
          let tbl = ["USER"];
          let column = ["BRANCH_ID"];
          let value = [this.mybranchid];
          
          let tblkey = ["No"];
          let fktbl = ["No"];
          let fkkey = ["No"];

          let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

          let mydata = Object.assign(jsonitem);
          let json_data = this.serviceapi.json_readdata(mydata,"1");
        

          this.serviceapi.readdata(json_data,"USER","1","1").then((result) => {
          
            this.Status = result["Message"];
            if (this.Status == '1'){
              
              let Records = result["Records"];
              this.userArr = Records;
              this.userItems = this.userArr;
            }
            else {
              this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
            }
          }, (err) => {
            this.errorMessage = "Loading Error. Please try again.";
            this.loading.dismiss();
          });
        }
        else {
         
        }
      }, (err) => {
       
      
      });

    }
    

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];

    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"BRANCH","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        this.loading.dismiss();
        let Records = result["Records"];
        this.branchArr = Records;
        this.branchItems = this.branchArr;
        
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B08eInvoiceSummaryPage');
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });

    this.loading.present();
  }

  onChangeCorp(data){
    this.BRANCH_ID = data;
  }

  goTo(){
    this.navCtrl.setRoot(B08ReportManagementPage);
  }

  generate(){
    console.log(this.report_request);
    this.showLoader();

    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      
      if (this.Status == '1'){
        this.OVERALL = result["Overall"];
        let Records = result["Records"];
        this.reportItems = Records;
        console.log(this.reportItems)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  download(){
    this.showLoader();
    this.report_request.Param = "2";
    this.serviceapi.reportrequest(this.report_request).then((result) => {
      this.loading.dismiss();
      this.Status = result["Message"];
      if (this.Status == '1'){
        this.OVERALL = result["Overall"];
        let Records = result["Records"];
        this.reportItems = Records;
        let file = result["File"];
        let path = file.replace('..','');
        let url = this.global.URL+"/api";
        var remove = path.substring(0, path.lastIndexOf("/"));
        console.log(remove);
        var splitTest = file.split('\\').pop().split('/').pop();
        this.filename=url+remove+"/"+splitTest;
        console.log(this.filename);
        window.open(this.filename,"_blank");
        console.log(this.reportItems)
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }

  clearFilter(){
    this.BRANCH_ID = 'All';
    this.USER_ID = 'All';
   
    this.report_request.Data.START = '';
    this.report_request.Data.END = '';
  }
}



// WEBPACK FOOTER //
// ./src/pages/b08g-shift-sales/b08g-shift-sales.ts